import React, { FunctionComponent } from "react";

interface Props {
    isDisable: boolean,
    isRotated: boolean,
    onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const ArrowButton: FunctionComponent<Props> = ({ onClick, isDisable = true, isRotated = true }) =>
    <div className={`arrow-button ${isDisable ? "disable" : ""}`}
        onClick={onClick}>
        <img className={isRotated ? "rotated" : "not-rotated"} src={"/assets/images/responsive/icons/arrow-black.svg"} width="24" height="24" alt={"bouton retour en arriere"} />
    </div>
